module.exports = __webpack_public_path__ + "static/media/2.6d126d3d.jpg";